// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-link {
  cursor: pointer !important;
}

.reset-default {
  padding: 0px !important;
}

.admin {
  display: flex;
}

.admin-title {
  margin-right: 10px;
}

.user-info {
  padding-left: 10px !important;
}

.user-id {
  height: 18px !important;
}

.az-img-user {
  cursor: pointer;
}

.cursor-on {
  cursor: pointer;
  font-size: 24px;
}

.m-tenant {
  margin-left: 0px;
  margin-right: 0px;
}

.tenant-info {
  margin-top: 5px !important;
}

.tenant-icon {
  font-size: 28px !important;
}

.icon-size {
  max-width: 60px !important;
  margin-left: 10px !important;
}

.r-10 {
  margin-right: 0px !important;
}

.text-center {
  text-align: center;
}

.username {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 160px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImhlYWRlci5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLDBCQUFBO0FBQ0o7O0FBRUE7RUFDSSx1QkFBQTtBQUNKOztBQUVBO0VBQ0ksYUFBQTtBQUNKOztBQUNBO0VBQ0ksa0JBQUE7QUFFSjs7QUFBQTtFQUNJLDZCQUFBO0FBR0o7O0FBREE7RUFDSSx1QkFBQTtBQUlKOztBQUZBO0VBQ0ksZUFBQTtBQUtKOztBQUhBO0VBQ0ksZUFBQTtFQUNBLGVBQUE7QUFNSjs7QUFKQTtFQUNJLGdCQUFBO0VBQ0EsaUJBQUE7QUFPSjs7QUFMQTtFQUNJLDBCQUFBO0FBUUo7O0FBTkE7RUFDSSwwQkFBQTtBQVNKOztBQVBBO0VBQ0ksMEJBQUE7RUFDQSw0QkFBQTtBQVVKOztBQVJBO0VBQ0ksNEJBQUE7QUFXSjs7QUFSQTtFQUNJLGtCQUFBO0FBV0o7O0FBUkE7RUFDSSxnQkFBQTtFQUNBLHVCQUFBO0VBQ0EsbUJBQUE7RUFDQSxjQUFBO0VBQ0EsWUFBQTtBQVdKIiwiZmlsZSI6ImhlYWRlci5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5uYXYtbGluayB7XG4gICAgY3Vyc29yOiAgcG9pbnRlciAhaW1wb3J0YW50O1xufVxuXG4ucmVzZXQtZGVmYXVsdCB7XG4gICAgcGFkZGluZzogMHB4ICFpbXBvcnRhbnQ7XG59XG5cbi5hZG1pbiB7XG4gICAgZGlzcGxheTogZmxleDtcbn1cbi5hZG1pbi10aXRsZXtcbiAgICBtYXJnaW4tcmlnaHQ6IDEwcHg7XG59XG4udXNlci1pbmZvIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDEwcHggIWltcG9ydGFudDtcbn1cbi51c2VyLWlkIHtcbiAgICBoZWlnaHQ6IDE4cHggIWltcG9ydGFudDtcbn1cbi5hei1pbWctdXNlcntcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG59XG4uY3Vyc29yLW9ue1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICBmb250LXNpemU6IDI0cHg7XG59XG4ubS10ZW5hbnR7XG4gICAgbWFyZ2luLWxlZnQ6IDBweDtcbiAgICBtYXJnaW4tcmlnaHQ6IDBweDtcbn1cbi50ZW5hbnQtaW5mbyB7XG4gICAgbWFyZ2luLXRvcDogNXB4ICFpbXBvcnRhbnQ7XG59XG4udGVuYW50LWljb257XG4gICAgZm9udC1zaXplOiAyOHB4ICFpbXBvcnRhbnQ7XG59XG4uaWNvbi1zaXplIHtcbiAgICBtYXgtd2lkdGg6IDYwcHggIWltcG9ydGFudDtcbiAgICBtYXJnaW4tbGVmdDogMTBweCAhaW1wb3J0YW50O1xufVxuLnItMTB7XG4gICAgbWFyZ2luLXJpZ2h0OiAwcHggIWltcG9ydGFudDsgXG59XG5cbi50ZXh0LWNlbnRlciB7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuXG4udXNlcm5hbWUge1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG4gICAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgICBkaXNwbGF5OiBibG9jaztcbiAgICB3aWR0aDogMTYwcHg7XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/shared/header/header.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AACA;EACI,kBAAA;AAEJ;;AAAA;EACI,6BAAA;AAGJ;;AADA;EACI,uBAAA;AAIJ;;AAFA;EACI,eAAA;AAKJ;;AAHA;EACI,eAAA;EACA,eAAA;AAMJ;;AAJA;EACI,gBAAA;EACA,iBAAA;AAOJ;;AALA;EACI,0BAAA;AAQJ;;AANA;EACI,0BAAA;AASJ;;AAPA;EACI,0BAAA;EACA,4BAAA;AAUJ;;AARA;EACI,4BAAA;AAWJ;;AARA;EACI,kBAAA;AAWJ;;AARA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AAWJ;AACA,w2DAAw2D","sourcesContent":[".nav-link {\n    cursor:  pointer !important;\n}\n\n.reset-default {\n    padding: 0px !important;\n}\n\n.admin {\n    display: flex;\n}\n.admin-title{\n    margin-right: 10px;\n}\n.user-info {\n    padding-left: 10px !important;\n}\n.user-id {\n    height: 18px !important;\n}\n.az-img-user{\n    cursor: pointer;\n}\n.cursor-on{\n    cursor: pointer;\n    font-size: 24px;\n}\n.m-tenant{\n    margin-left: 0px;\n    margin-right: 0px;\n}\n.tenant-info {\n    margin-top: 5px !important;\n}\n.tenant-icon{\n    font-size: 28px !important;\n}\n.icon-size {\n    max-width: 60px !important;\n    margin-left: 10px !important;\n}\n.r-10{\n    margin-right: 0px !important; \n}\n\n.text-center {\n    text-align: center;\n}\n\n.username {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: block;\n    width: 160px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
